import { defineMessages } from 'react-intl';

export default defineMessages({
    save: {
        id: '_.your_company.prompt.save',
        defaultMessage: 'Save'
    },
    update: {
        id: '_.your_company.prompt.update',
        defaultMessage: 'Update'
    },
    cancel: {
        id: '_.your_company.prompt.cancel',
        defaultMessage: 'Cancel'
    }
});
